@if (expandMenuDrawer$ | async) {}
<div
  class="h-full st-side-menu-drawer overflow-hidden no-print"
  stSideDrawer
  [isOpen]="isOpen()"
  [direction]="'left'"
  [maxWidth]="this.maxWidth()"
>
  <st-mobile-main-sections-left-menu
    [homeButton]="homeButton()"
    [navigationList]="navigationList()"
    [profile]="profile()"
    [settingURL]="settingURL()"
    [tools]="tools()"
    (sectionSelected)="selectionItem($event)"
    class="drawer-hide-when-closed"
    [class.drawer-open]="!showContent()"
    [class.drawer-closed]="showContent()"
    [style.width]="this.maxWidth()"
    (toolsOpen)="openTools()"
  ></st-mobile-main-sections-left-menu>
  <st-menu-drawer-section-content
    [navigationItem]="this.navigationItem()"
    [style.width]="this.maxWidth()"
    (hideContent)="hideContent()"
    [class.drawer-open]="showContent()"
    [class.drawer-closed]="!showContent()"
    [tools]="toolsContent()"
  ></st-menu-drawer-section-content>
</div>
